import request from './request'

/**
 * 管理端登录
 * @param {object} params 管理端登录请求参数
 * @param {string} params.account 账号：用户名或手机号
 * @param {string} params.password 密码
 * @returns {Promise}
 */
export function adminLogin(params) {
  return request.post('/api/login/admin', params)
}

